<template>
  <div class="space-y-6">
    <div
      v-for="section in sectionsWithCitations"
      :key="section.title"
      data-testid="response-section"
    >
      <h3 class="text-nash-midnightBlue700 font-semibold mb-2">
        {{ section.title }}
      </h3>
      <div v-if="section.error" class="italic text-nash-neutral600">
        An error occurred while generating this section. Please try again.
      </div>
      <div v-else-if="section.response">
        <div class="grid grid-cols-2 gap-4">
          <div>
            <h4 class="text-nash-midnightBlue700 font-medium mb-1">
              Response:
            </h4>
            <TMarkdown :source="section.response.response" />
          </div>
          <div>
            <h4 class="text-nash-midnightBlue700 font-medium mb-1">Sources:</h4>
            <LlmSource
              v-for="source in section.sortedCitations"
              :key="source.sourceId"
              :source="source"
              :patient-id="patientId"
            />
            <div
              v-if="section.sortedCitations.length === 0"
              class="italic text-nash-neutral600"
            >
              No sources could be generated. Please verify the answer on the
              patient profile.
            </div>
            <div class="mt-4 font-semibold">Patient Data Checked:</div>
            <div v-if="section.toolsToShow.length === 0" class="italic mt-2">
              No patient data was checked in generating this answer.
            </div>
            <ul v-else class="list-none list-inside">
              <li
                v-for="tool in section.toolsToShow"
                :key="tool.toolName"
                class="mb-2"
              >
                <div class="flex items-center gap-2">
                  <TIcon class="inline" icon="wrench" />
                  {{ formatToolCall(tool) }}
                </div>
              </li>
            </ul>
          </div>
        </div>

        <LlmFeedback
          v-if="section.showFeedback && section.loggingDetails"
          :raw-log-id="section.loggingDetails.rawLogId"
          :datadog-logging-details="section.loggingDetails"
        />
        <hr class="my-2 h-px" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import TIcon from '@thyme/nashville/src/components/icon/TIcon.vue'
import { defineComponent } from 'vue'
import TMarkdown from '@/legacy/nashville/text/TMarkdown.vue'
import LlmFeedback from '@/tokens/llm/LlmFeedback/LlmFeedback.vue'
import setup from './controller'
import LlmSource from './LlmSource/LlmSource.vue'
import { RESPONSE_CONTENT_PROPS } from './types'

export default defineComponent({
  name: 'ResponseContent',
  components: {
    TMarkdown,
    TIcon,
    LlmSource,
    LlmFeedback,
  },
  props: RESPONSE_CONTENT_PROPS,
  setup,
})
</script>
